import { getLocalizedNumber } from 'src/Libs/languages/functions/default'

/**
 * Format a number in a compact way for pie chart labels.
 * Could be replaced by Intl.NumberFormat with option "compact" once this is supported in all browsers.
 */
export const formatPieChartLabel = (savingsSum: number): string => {
  if (savingsSum < 0) {
    return '-' + formatPieChartLabel(-1 * savingsSum)
  }

  if (savingsSum >= 1000 && savingsSum < 10_000) {
    return getLocalizedNumber(savingsSum.toFixed(0))
  } else if (savingsSum >= 10_000 && savingsSum < 1_000_000) {
    return (savingsSum / 1000).toFixed(1).replace(/\.0$/, '') + 'k'
  } else if (savingsSum >= 1_000_000 && savingsSum < 1_000_000_000) {
    return (savingsSum / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'
  }

  return getLocalizedNumber(savingsSum)
}
